module.exports = __webpack_public_path__ + "static/case_study_turystyczna_back-d4f9dfb8401599a0967add38d2ba3af6.png";